import * as Dialog from '@radix-ui/react-dialog'
import styles from './StatusModal.module.css'
import { useCallback, useEffect, useState } from 'react'
import { MatchingPaymentTicket } from '../../core/_models'
import { Spinner } from 'react-bootstrap'
import { VisuallyHidden } from 'radix-ui'

/**
 * @todo Вынести это в общий компонент вместе с аналогом из payment-tickets.
 *
 * В payment-tickets сделать рефакторинг, вытащив оттуда всю логику в вышестоящий компонент
 *
 * Сама модалка как компонент должна быть dumb component и не иметь в себе бизнес-логики,
 * ее ответственность — принять ввод любой суммы и отдать наверх, либо закрыться без изменений.
 * Отвязать от "Status" и ticket, принимать абстрактный generic. Пропасами должны переопределяться:
 * - все тексты
 * - валидатор (ф-цией)
 * - какой-то произвольный блок под заголовком в виде ReactNode
 */
const StatusModal = ({
  ticket,
  onSubmit,
  onClose,
}: {
  ticket: MatchingPaymentTicket | null
  onSubmit: (ticket: MatchingPaymentTicket | null, amount: number) => Promise<void>
  onClose: () => void
}) => {
  const [amount, setAmount] = useState<number | ''>(ticket?.amount ?? '')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  const handleSubmit = useCallback(
    async (amount: number) => {
      setIsLoading(true)
      try {
        await onSubmit(ticket, amount)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
        onClose()
      }
    },
    [onSubmit, onClose, ticket]
  )

  useEffect(() => {
    setAmount(ticket?.amount ?? '')
  }, [ticket])

  return (
    <div style={{ position: 'absolute' }}>
      <Dialog.Root open={!!ticket}>
        <Dialog.Portal>
          <Dialog.Overlay className={styles.overlay} onClick={onClose} />

          <VisuallyHidden.Root>
            <Dialog.Title>Завершить пополнение</Dialog.Title>
            <Dialog.Description>Введите сумму пополнения</Dialog.Description>
          </VisuallyHidden.Root>

          <Dialog.Content className={styles.content}>
            {ticket?.ticketToken}
            <div className={styles.inpits}>
              <label htmlFor='exampleInputEmail1' className='form-label mb-6'>
                Введите сумму
              </label>
              <input
                type='number'
                min='0'
                className='form-control'
                id='exampleInputEmail1'
                aria-describedby='emailHelp'
                placeholder='Сумма'
                onChange={(e) => setAmount(e?.target?.value ? Number(e?.target?.value ?? '') : '')}
                value={amount ?? undefined}
              />
            </div>
            <div className={styles.buttons}>
              <button
                onClick={() => handleSubmit(amount || 0)}
                type='button'
                className={`btn btn-primary c ${amount === 0 ? 'disabled' : ''}`}
                disabled={isLoading || typeof amount !== 'number' || amount < 0}
              >
                {isLoading ? <Spinner className={styles.spinner} /> : 'Завершить'}
              </button>

              <button
                onClick={handleClose}
                type='button'
                className='btn btn-danger'
                disabled={isLoading}
              >
                Отмена
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  )
}

export default StatusModal
